import * as React from "react";
import { cn } from "@/lib/utils";
import { useTenantLogoUrl } from "@/hooks/useTenantProfile";

interface TenantLogoImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
  logoKey: string;
  className?: string;
}

export const TenantLogoImage = ({
  logoKey,
  className,
  alt,
  ...props
}: TenantLogoImageProps) => {
  const { data: src } = useTenantLogoUrl(Boolean(logoKey));

  if (!src) {
    return null;
  }

  return <img src={src} alt={alt} className={cn("", className)} {...props} />;
};
